import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const PresentMessage = (type, message) => {
  function decideMessage() {
    if (type === 'error') {
      const newErr = message.replace(/Error: /g, '');
      toast.error(newErr, {
        position: 'top-right',
        autoClose: 4000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    }
    if (type === 'success') {
      toast.success(message, {
        position: 'top-right',
        autoClose: 4000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    }
    if (type === 'warn') {
      toast.warn(message, {
        position: 'top-right',
        autoClose: 4000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    }
    if (type === 'info') {
      toast.info(message, {
        position: 'top-right',
        autoClose: 4000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    }
  }

  return decideMessage();
};

export default PresentMessage;
